export enum DocumentTypeEnum {
    WorkProduct = 1,
    OfficialCaseDocument = 2,
    Report = 3,
    DataExport = 4,
    ScreenPDF = 5,
    Case = 6,
    CaseNote = 7,
    ZoneNote = 8,
    PackageDeal = 9,
    PackageDealNote = 10,
    Strategy = 11,
    StrategyNote = 12,
    //// TODO Update API
    CaseExpert = 13,
}

export enum DocumentSubTypeEnum {
    QueryExport = 1,
    StrategySignificantChanges = 2,
    StrategicPlanExport = 3,
    ExecutionPlanExport = 4,
    Trends = 5,
    Snapshot = 6,
    Board = 7,
    PlaintiffsFirm = 8,
    Jurisdiction = 9,
    LocalCounsel = 10,
    Project = 11,
    Expert = 12,
}
